import { gql } from '@apollo/client';

import { dispatch } from 'src/state';
// graphql
import { apolloClient } from 'src/lib/apollo-client';
import * as ActionTypes from 'src/state/action-types';

// Action

export function updateEmailPreferencesSuccess(newsletter: boolean) {
  return {
    type: ActionTypes.USER_UPDATE_EMAIL_PREFERENCE_SUCCESS,
    payload: { newsletter },
  };
}

export function deleteAccountSuccess() {
  return {
    type: ActionTypes.USER_DELETE_ACCOUNT_SUCCESS,
  };
}

export function changePasswordSuccess() {
  return {
    type: ActionTypes.USER_CHANGE_PASSWORD_SUCCESS,
  };
}

export function changeEmailSuccess(email: string) {
  return {
    type: ActionTypes.USER_CHANGE_EMAIL_SUCCESS,
    payload: { email },
  };
}

export function updateUserSettings(
  update: Partial<{
    firstName: string;
    lastName: string;
    imageUrl: string;
    language: string;
    role: string;
    folderView: 'grid' | 'list';
  }>
) {
  return async () => {
    dispatch({
      type: ActionTypes.USER_UPDATE_SETTINGS_REQUEST,
      payload: update,
    });

    if (update.language) {
      document.cookie = `language=${update.language}; path=/;SameSite=Lax;domain=${window.location.hostname === 'localhost' ? 'localhost' : '.lumi.education'}`;
    }

    try {
      await apolloClient.mutate({
        mutation: gql`
          mutation UpdateMe(
            $lastName: String
            $firstName: String
            $imageUrl: String
            $language: String
            $role: String
            $folderView: String
          ) {
            updateMe(
              input: {
                lastName: $lastName
                firstName: $firstName
                imageUrl: $imageUrl
                language: $language
                role: $role
                folderView: $folderView
              }
            ) {
              imageUrl
            }
          }
        `,
        variables: {
          lastName: update.lastName,
          firstName: update.firstName,
          imageUrl: update.imageUrl,
          language: update.language,
          role: update.role,
          folderView: update.folderView,
        },
        fetchPolicy: 'network-only',
      });

      dispatch({
        type: ActionTypes.USER_UPDATE_SETTINGS_SUCCESS,
        payload: update,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.USER_UPDATE_SETTINGS_FAILURE,
        payload: error,
      });
    }
  };
}
